var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"simpleRules"},[_c('mod-leads-item-form'),_c('save-button',{attrs:{"save-action":_vm.submitForm,"is-disabled":_vm.submitStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }